const _ = require('lodash')

function compileTemplate(template) {
  return _.template(template, {
    interpolate: /{{([\s\S]+?)}}/g
  })
}

module.exports = compileTemplate
